<div class="profile-tab">

  <div class="profile-loading" *ngIf="loading">
    <mat-spinner diameter="26"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading">

    <!-- ─── Identity card ─── -->
    <section class="profile-card" *ngIf="profile">
      <div class="profile-avatar">
        <img *ngIf="profile.photoUrl; else initials" [src]="profile.photoUrl" [alt]="profile.displayName">
        <ng-template #initials><mat-icon>person</mat-icon></ng-template>
      </div>
      <div class="profile-identity">
        <h3>{{ profile.displayName }}</h3>
        <p class="profile-role" *ngIf="profile.jobTitle || profile.department">
          {{ profile.jobTitle }}<span *ngIf="profile.jobTitle && profile.department"> · </span>{{ profile.department }}
        </p>
        <p class="profile-company" *ngIf="profile.companyName">{{ profile.companyName }}</p>
      </div>
      <button mat-icon-button matTooltip="Refresh" aria-label="Refresh profile" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
    </section>

    <section class="profile-section" *ngIf="profile">
      <h4>Contact</h4>
      <dl class="profile-facts">
        <ng-container *ngIf="profile.mail || profile.userPrincipalName">
          <dt>Email</dt><dd>{{ profile.mail || profile.userPrincipalName }}</dd>
        </ng-container>
        <ng-container *ngIf="profile.mobilePhone">
          <dt>Mobile</dt><dd>{{ profile.mobilePhone }}</dd>
        </ng-container>
        <ng-container *ngIf="profile.businessPhones.length">
          <dt>Work</dt><dd>{{ profile.businessPhones[0] }}</dd>
        </ng-container>
        <ng-container *ngIf="profile.officeLocation">
          <dt>Office</dt><dd>{{ profile.officeLocation }}</dd>
        </ng-container>
        <ng-container *ngIf="profile.city || profile.country">
          <dt>Location</dt>
          <dd>{{ profile.city }}<span *ngIf="profile.city && profile.country">, </span>{{ profile.country }}</dd>
        </ng-container>
      </dl>
    </section>

    <!-- ─── Mailbox settings ─── -->
    <section class="profile-section" *ngIf="isPersonal">
      <h4>Mailbox settings</h4>
      <p class="profile-note">
        <mat-icon>info_outline</mat-icon>
        Mailbox settings aren't available for personal Microsoft accounts.
      </p>
    </section>

    <section class="profile-section" *ngIf="!isPersonal && settings">
      <h4>Mailbox settings</h4>

      <div class="profile-auto-reply" [class.profile-auto-reply--on]="autoRepliesOn">
        <div class="profile-auto-reply__head">
          <mat-icon>{{ autoRepliesOn ? 'event_busy' : 'event_available' }}</mat-icon>
          <span>Automatic replies</span>
          <span class="profile-badge">{{ autoRepliesLabel }}</span>
        </div>
        <p class="profile-auto-reply__window"
           *ngIf="settings.automaticReplies?.scheduledStart && settings.automaticReplies?.scheduledEnd">
          {{ settings.automaticReplies?.scheduledStart | date:'d MMM y, HH:mm' }}
          →
          {{ settings.automaticReplies?.scheduledEnd | date:'d MMM y, HH:mm' }}
        </p>
        <p class="profile-auto-reply__message" *ngIf="autoRepliesOn && settings.automaticReplies?.internalReplyMessage">
          {{ settings.automaticReplies?.internalReplyMessage }}
        </p>
      </div>

      <dl class="profile-facts">
        <ng-container *ngIf="settings.timeZone"><dt>Time zone</dt><dd>{{ settings.timeZone }}</dd></ng-container>
        <ng-container *ngIf="settings.language"><dt>Language</dt><dd>{{ settings.language }}</dd></ng-container>
        <ng-container *ngIf="settings.dateFormat"><dt>Date format</dt><dd>{{ settings.dateFormat }}</dd></ng-container>
        <ng-container *ngIf="settings.workingHours">
          <dt>Working hours</dt>
          <dd>{{ settings.workingHours?.startTime }} – {{ settings.workingHours?.endTime }}</dd>
        </ng-container>
      </dl>
    </section>

    <!-- ─── Account / diagnostics ─── -->
    <section class="profile-section profile-section--account" *ngIf="account">
      <h4>Connected account</h4>
      <dl class="profile-facts">
        <dt>Signed in as</dt><dd>{{ account.username }}</dd>
        <dt>Tenant</dt><dd class="profile-mono">{{ account.tenantId }}</dd>
        <dt>Type</dt><dd>{{ account.isPersonal ? 'Personal Microsoft account' : 'Work or school account' }}</dd>
      </dl>
      <button mat-stroked-button class="profile-signout" (click)="signOut()">
        <mat-icon>logout</mat-icon>
        <span>Sign out of Outlook</span>
      </button>
      <p class="profile-note profile-note--quiet">
        Signing out only disconnects Outlook. It doesn't sign you out of Klidi.
      </p>
    </section>

  </ng-container>
</div>
